import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useRecoilState } from "recoil";
import { putDetectCancel } from "../api/detect";
import { accidentState } from "../atoms/accident";
import { PatchCancelParams } from "../types/types";
import { useSnackbar } from "notistack";

interface Params extends PatchCancelParams {
  afterPatched: () => void;
  afterPatched2: any;
}
// 실시간 감지 내역 무쓸모화 시켜야함.
const usePutDetect = ({
  checker_name,
  header_seq,
  pid,
  reason,
  afterPatched,
  afterPatched2,
}: Params) => {
  const { enqueueSnackbar } = useSnackbar();
  const [, setAccident] = useRecoilState(accidentState);
  const queryClient = useQueryClient();
  const mutation = useMutation({
    mutationFn: () =>
      putDetectCancel({ checker_name, header_seq, pid, reason }),

    onSuccess: () => {
      enqueueSnackbar(`사고 감지 해제 성공`, {
        variant: "success",
      });
      afterPatched();
      afterPatched2("");
      setAccident(null);
      queryClient.invalidateQueries({ queryKey: ["DetectLive"] });
    },
  });
  return mutation;
};

export default usePutDetect;
